import { useState, useEffect } from "react";
import apiClient from "../../services/apiClient";
import { getCookie } from "../../utils/cookies";
import toast from "../../utils/toast";

export default function CreateComplain() {
  const [departmentType, setDepartmentType] = useState("");
  const [departmentList, setDepartmentList] = useState([]);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchDepartmentList();
  }, []); 

  const fetchDepartmentList = async () => {
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const res = await apiClient.post("/App/GetDepartmentList", {
        appSession: {
          appid: "ROUNDPAYAPPID13APR20191351",
          imei: "d593bdd26dfbea56",
          loginTypeID: 1,
          regKey: "",
          serialNo: "d593bdd26dfbea56",
          session: getCookie("session") || "",
          sessionID: getCookie("sessionID") || "",
          uid: 0,
          userID: userData.userID || "",
          version: "1.0",
        },
        request: {
          IsSupportExecutive: true,
        },
      });

      if (res.statuscode == 1) {
        setDepartmentList(res.data || []);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  async function handleSubmit() {
    if (!departmentType) {
      toast.error("Please select a department");
      return;
    }
    if (!subject.trim()) {
      toast.error("Please enter a subject");
      return;
    }
    if (!message.trim()) {
      toast.error("Please enter a message");
      return;
    }

    setIsSubmitting(true);
    try {
      const userData = JSON.parse(getCookie("userData") || "{}");

      const ticketRequest = {
        UserID: userData.userID || "",
        SessionID: getCookie("sessionID") || "",
        Session: getCookie("session") || "",
        LoginTypeID: 1,
        APPID: "ROUNDPAYAPPID13APR20191351",
        IMEI: "d593bdd26dfbea56",
        SerialNo: "d593bdd26dfbea56",
        Version: "1.0",
        RegKey: "",
        DepartmentId: departmentType,
        TicketId: 0,
        Subject: subject,
        MessageBody: `<p>${message}</p>`,
        IsTicketStatusClosed: false,
      };

      const formData = new FormData();
      formData.append("TicketRequest", JSON.stringify(ticketRequest));
      attachments.forEach((file) => {
        formData.append("files", file, file.name);
      });

      const res = await apiClient.post(
        "/App/CreateTicketOrSendTicketResponse",
        formData,
        { headers: { "Content-Type": undefined } },
      );

      if (res.statuscode == 1) {
        toast.success(res.msg);
        setDepartmentType("");
        setSubject("");
        setMessage("");
        setAttachments([]);
      } else {
        toast.error(res.msg);
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Failed to create ticket. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="content">
      <section className="page active" id="page-create-complain">
        <div className="card" style={{ maxWidth: 1200 }}>
          <div className="card-head">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path d="M21 11.5a8.4 8.4 0 01-8.9 8.4 8.7 8.7 0 01-4-1L3 20l1.1-4.3A8.4 8.4 0 1121 11.5z" />
            </svg>
            <h3>Create Ticket</h3>
          </div>

          <div className="grid grid-2">
            <div className="field">
              <label>Department Type</label>
              <select
                value={departmentType}
                onChange={(e) => setDepartmentType(e.target.value)}
              >
                <option value="">-- Select Department --</option>
                {departmentList.map((dept) => (
                  <option key={dept.id} value={dept.id}>
                    {dept.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="field">
              <label>Subject</label>
              <input
                type="text"
                placeholder="Please enter subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>
          </div>

          <div className="grid grid-2">
            <div className="field">
              <label>Message</label>
              <textarea
                placeholder="Type your message..."
                style={{ minHeight: 170 }}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <div className="field">
              <label>Attachment</label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.pdf"
                multiple
                onChange={(e) => {
                  const newFiles = Array.from(e.target.files || []);
                  setAttachments((prev) => [...prev, ...newFiles]);
                  e.target.value = "";
                }}
              />
              <div
                className="field-note"
                style={{ color: "var(--text-faint)" }}
              >
                Allowed file extensions: .jpg, .jpeg, .png, .pdf
              </div>
              {attachments.length > 0 && (
                <div
                  style={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  {attachments.map((file, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: "var(--bg-elev-2)",
                        border: "1px solid var(--border)",
                        borderRadius: 7,
                        padding: "6px 10px",
                        fontSize: 12.5,
                      }}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {file.name}
                      </span>
                      <span
                        onClick={() =>
                          setAttachments((prev) =>
                            prev.filter((_, i) => i !== idx),
                          )
                        }
                        style={{
                          cursor: "pointer",
                          color: "var(--text-faint)",
                          marginLeft: 10,
                        }}
                      >
                        &times;
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="btn-primary"
              style={{ width: "auto", padding: "12px 32px" }}
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
